<div class="row g-4">
    @if (access.yardCapacity) {
        <div class="col-12 col-lg-4">
            <app-dashboard-card title="Yard Capacity">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadYardCapacity"
                    [palette]="palettes.yardCapacity"
                    centerText="My Score"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.shuntProductivity) {
        <div class="col-12 col-lg-4">
            <app-dashboard-card title="Shunt Productivity">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [employeeId]="shuntUserId"
                    [loadData]="loadShuntProductivity"
                    [palette]="palettes.shuntProductivity"
                    centerText="Completed Shunts"
                    formatMode="decimal"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.emptyTrailerAging) {
        <div class="col-12 col-lg-4">
            <app-dashboard-card title="Empty Trailer Aging">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadEmptyTrailerAging"
                    [palette]="palettes.emptyTrailerAging"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.yardCapacity) {
        <div class="w-100 mt-0"></div>
        @for (chart of yardCapacityBreakdowns; track chart.scoreType) {
            <div class="col-12 col-lg-6">
                <app-dashboard-card [title]="chart.scoreType | capitalCase">
                    <app-doughnut-chart
                        [from]="from"
                        [to]="to"
                        [loadData]="chart.loadData"
                        [palette]="palettes.yardCapacityBreakdown"
                        [centerText]="chart.scoreType | capitalCase"
                        [responsive]="false"
                    ></app-doughnut-chart>
                </app-dashboard-card>
            </div>
        }
    }
</div>
